// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"31675f89","455":"c1a2e1f3","520":"fffadc2b","557":"0cdc9980","644":"a9ae9382","668":"8fa13eb4","762":"d64dc719"}[chunkId] + ".chunk.js";
};